import script from "./OpenDataCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenDataCatalog.vue?vue&type=script&setup=true&lang=js"

import "./OpenDataCatalog.vue?vue&type=style&index=0&id=1cf676fd&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/API-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf676fd"]])

export default __exports__